import http from "infra/http";
import { useMutation } from "react-query";
import { AreaComumUnidadeBloqueioForm } from "../typings";

function useBloquearUnidade() {
  return useMutation(
    `/v1/bloqueio-reserva`,
    (data: AreaComumUnidadeBloqueioForm) =>
      data.id
        ? http.put(`/v1/bloqueio-reserva/${data.id}`, data)
        : http.post(`/v1/bloqueio-reserva`, data),
    { retry: false }
  );
}

export default useBloquearUnidade;
